import React from 'react';
import { Icon, Dropdown, } from 'antd';
import BaseComponent from 'components/BaseComponent';
import { 
    FiletypeComb,
    getDefaultFileName 
} from 'components/Playlist';
import { MaterialComponent } from '@/routes/Material/Util/components/materialComponent';
import Button from '../Button';

export default class MaterialLib extends BaseComponent {
    constructor() {
        super();
        this.state = {
            record: null,
            visible: false,
            showVisible: false,
            materialLibHeight: 0,
            permutationType: 1,
        };
    }

    showPlaylistDetails = (e) => {
        if (e) e.stopPropagation();
        this.setState({
            showVisible: true
        });
    };

    hideModelHandler = (e) =>{
        if (e) e.stopPropagation();
        this.setState({
            showVisible: false
        });
    }

    getMenu = () => {
        return (
            <FiletypeComb  onClick={this.qryMaterial }/>
        );
    }
    qryMaterial = (event) => {
        let { changeMaterialType } = this.props;
        changeMaterialType(event.key);
    }

    getMaterialLibHeight = (type) => {
        let { winHeight } = this.props;
        let materialLibHeight = 0;
        if(type === 0){
            materialLibHeight = winHeight - 90 - 2;
        }else if(type === 1){
            materialLibHeight = winHeight - 132 - 2;
        }
        this.setState({
            materialLibHeight: materialLibHeight
        })
        return materialLibHeight;
    }

    componentDidMount(){
        this.getMaterialLibHeight(0);
    }

	clickBlankAreaClear = (e) => {
		if (e) {
            e.stopPropagation();
			if (e.target.nodeName === "DIV") {
				this.props.onClearMaterialLib();
			}
		}
	}

    render() {
        let { materialType: type, 
            visible, materialRows, 
            onMouseDown, onMouseUp, onDragStart, onDragEnd, 
            onClearMaterialLib } = this.props;

        let { materialLibHeight } = this.state;

        const picProps = {
            title: '图片',
            visible: visible,
            height: materialLibHeight,
            type,
            defaultShow: '0',//0 缩略图  1 列表
            isShowText: true,
            isUpload: true,
            onOk: this.onOk, // 对选中的值进行操作
            onCancel: this.onCancel, // 关闭模态窗口
            checkRows: materialRows, // 选中的值
			checkKeys: materialRows.map((item) => item.id),
			onClearChecked: onClearMaterialLib, // 清除选中数据
            showPlaylistDetails: this.showPlaylistDetails,
            clickBlankAreaClear: this.clickBlankAreaClear,
            onMouseDown,
            onMouseUp,
            onDragStart,
            onDragEnd,
            getMaterialLibHeight: this.getMaterialLibHeight,
            permutationType:this.state.permutationType,
        };
        return (
            <div>
                <MaterialComponent {...picProps} className="materialLib-content" >
                    <Dropdown overlay={ this.getMenu() }>
                        <Button>
                            {getDefaultFileName(type)}<Icon type="down" />
                        </Button>
                    </Dropdown>
                    {/* <Button onClick={() => this.showPlaylistDetails()}>查看详情</Button> */}
                </MaterialComponent>
                {/* <ModalDetails {...playlistdetailsProps} /> */}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Playlist/MaterialLib.js